module.exports = {"Dashboard.title":"Dong Hanh Technology - Quản trị khách hàng","menu.dashboard":"Trang chủ","user.displayName":"Tên người dùng","user.email":"Email","user.phone":"Điện thoại","user.password":"Mật khẩu","user.status":"Trạng thái","user.actived":"Hoạt động","user.notActived":"Khóa","user.addNew":"Thêm mới","msg.appAccessDeny":"Tài khoản của bạn không có quyền truy cập trang này!","meta.createTime":"Ngày tạo","table.action":"Thao tác","param_invalid.phones":"Số điện thoại không hợp lệ","email_exist":"Email đã tồn tại","confirm.delete":"Bạn có chắc chắn muốn xóa?"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/vi.json
// module id = 565
// module chunks = 3